import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { completeAccountingEntriesAction, getAccountingEntriesAction } from "../../actions";
import { getLocalizedString } from "@icarius-localization/strings";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getAccountingEntriesData, getIsLoadingAccountingEntries } from "@icarius-pages/currentProcesses/selectors";
import { openDialogAction } from "@icarius-common/dialog/actions";

const useAccountingEntries = () => {

  const dispatch = useDispatch();
  const isLoading = useSelector(getIsLoadingAccountingEntries);
  const arrayData = useSelector(getAccountingEntriesData);

  const [processName, setProcessName] = useState("");
  const [processCode, setProcessCode] = useState("");
  const [mainDialogIsOpen, setMainDialogIsOpen] = useState(false);
  const [missingAccountsDialogIsOpen, setMissingAccountsDialogIsOpen] = useState(false);

  const handleOpenMainDialog = (gridRef) => {
    //Obtener los seleccionados y armar array de files
    let selectedRows = gridRef.api.getSelectedRows();

    // Si no hay seleccionado, pido seleccionar
    if (selectedRows.length !== 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("youNeedOneRow"), severity: "warning" }));
      return;
    }

    dispatch(getAccountingEntriesAction(selectedRows[0]["Código de proceso"]))
      .then((resp) => {
        if (resp.data.status === "OK") {
          setProcessCode(selectedRows[0]["Código de proceso"]);
          setProcessName(selectedRows[0]["Descripción"]);
          setMainDialogIsOpen(true);
        }
      });
  };

  const handleCloseMainDialog = () => {
    setMainDialogIsOpen(false);
    setProcessCode("");
    setProcessName("");
  }

  const handleOpenMissingAccountsDialog = () => {
    setMissingAccountsDialogIsOpen(true);
  };

  const handleCloseMissingAccountsDialog = () => {
    setMissingAccountsDialogIsOpen(false);
  }

  const handleCompleteEntries = () => {
    dispatch(openDialogAction({
      title: getLocalizedString("atention"),
      msg: getLocalizedString("completeImputationsQuestionTitle"),
      onConfirm: () => {
        dispatch(openDialogAction({
          title: getLocalizedString("atention"),
          msg: (
            <>
              {getLocalizedString("completeImputationsQuestion1")}
              <br />
              <br />
              {getLocalizedString("completeImputationsQuestion2")}
              <br />
              <br />
              {getLocalizedString("completeImputationsQuestion3")}
            </>
          ),
          onConfirm: () => {
            dispatch(completeAccountingEntriesAction({ processCode }))
              .then((resp) => {
                if (resp.data.status === "OK") {
                  dispatch(getAccountingEntriesAction(processCode))
                    .then((resp) => {
                      if (resp.data.status === "OK") {
                        handleCloseMissingAccountsDialog();
                      }
                    });
                }
              });
          },
        }));
      },
    }));
  }

  const accountingEntriesData = {
    isLoading,
    processName,
    mainDialogIsOpen,
    missingAccountsDialogIsOpen,
    arrayData,
  };

  const accountingEntriesFunctions = {
    handleOpenMainDialog,
    handleCloseMainDialog,
    handleOpenMissingAccountsDialog,
    handleCloseMissingAccountsDialog,
    handleCompleteEntries,
  };

  return {
    accountingEntriesData,
    accountingEntriesFunctions,
  }
}

export default useAccountingEntries;
